<div
  (click)="onClick($event)"
  [ngClass]="{
    'message-replay': type === 'reply',
    'message-out': message.out,
    'message-in': !message.out
  }"
  class="message-body message-compact pointer py-2 py-lg-3"
>
  <!-- Message: row -->
  <div class="message-row">
    <div [class.justify-content-end]="message.out" class="d-flex align-items-center position-relative">
      <!-- Message: content -->
      <div *ngIf="!message.sticker && !message.voice; else messageNotContent" class="message-content">
        <app-message-attachments-compact
          [lvl]="lvl"
          *ngIf="message?.attachments?.length > 0 && !message.hidden"
          [Service]="Service"
          [message]="message"
          class="mt-2 d-block"
        ></app-message-attachments-compact>

        <div *ngIf="message.empty" class="text-break text-muted">
          <i>Сообщение удалено</i>
        </div>
        <div
          *ngIf="message.text"
          [innerHTML]="message.text | href | replaceEmojis: 'facebook':24:64"
          class="text-truncate"
        ></div>
      </div>

      <!-- Message: content -->
      <!-- Message: sticker -->
      <ng-template #messageNotContent>
        <div>
          <app-tgs-player
            *ngIf="message.sticker"
            [Service]="Service"
            [message]="message"
            [sticker]="message.sticker"
          ></app-tgs-player>
          <app-voice-player
            *ngIf="message.voice && !message.hidden"
            [Service]="Service"
            [message]="message"
            [voice]="message.voice"
          ></app-voice-player>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- https://speller.yandex.net/services/spellservice.json/checkText?text=ghbdtn%20rfr%20ltkf-->
